__turbopack_context__.v({
  "pinkBackground": "styles-module__IDuGZq__pinkBackground",
  "questionContainer": "styles-module__IDuGZq__questionContainer",
  "questionsContainer": "styles-module__IDuGZq__questionsContainer",
  "section": "styles-module__IDuGZq__section",
  "sectionTitle": "styles-module__IDuGZq__sectionTitle",
});
